import { Translation } from '@ps/web-shared-components';
import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import { StatusCode } from '@swf/core/enums/statusCode';

import AccountDate from '../../AccountDate/AccountDate';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_WeXll_automatically_reopen_you_ELL_1,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_YouXre_taking_a_break
} from './ExclusionResponseFR.messages.json';

interface Props {
  error?: boolean;
  statusCode?: StatusCode;
  endDate: Date;
}

const ExclusionResponseFR: React.FC<Props> = ({ error, statusCode, endDate }) => {
  const formattedEndDate = (
    <b>
      <AccountDate date={endDate} />
    </b>
  );

  switch (true) {
    case error:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );
    case statusCode === StatusCode.USER_SELF_EXCLUDED:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_taking_a_break}>
          <Translation
            {...TXTWCL_WeXll_automatically_reopen_you_ELL_1}
            values={{ 0: formattedEndDate }}
          />
        </InfoMessage>
      );
    default:
      return (
        <>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation {...TXTWCL_WeXll_automatically_reopen_you_ELL} />
        </>
      );
  }
};

export default ExclusionResponseFR;
